var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.449,
    height: 54.481,
    viewBox: "1388.724 258.888 54.449 54.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "box"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1400.616 259.142a1.296 1.296 0 0 0-.892.396l-10.288 10.291-.083.078a1.296 1.296 0 0 0-.283.425 1.295 1.295 0 0 0-.09.4l-.006.09v41.485a1.296 1.296 0 0 0 1.493 1.296h41.288l.042-.005a1.292 1.292 0 0 0 .124-.01 1.29 1.29 0 0 0 .213-.044h.005l.036-.01a1.29 1.29 0 0 0 .122-.052c.027-.013.054-.025.08-.04l.032-.02a1.301 1.301 0 0 0 .212-.153l.052-.044.013-.016 10.358-10.355c.243-.244.38-.574.379-.918V260.45c0-.583-.39-1.095-.952-1.25a1.296 1.296 0 0 0-.127-.03 1.297 1.297 0 0 0-.127-.016 1.298 1.298 0 0 0-.09 0h-41.247a1.296 1.296 0 0 0-.264-.016Zm.562 2.608h37.819l-7.778 7.778H1393.4l7.778-7.778Zm39.652 1.833v37.819l-7.778 7.778v-37.818l7.778-7.779Zm-49.263 8.538h38.892v38.892h-38.892v-38.892Zm2.593 23.335v2.593h15.557v-2.593h-15.557Zm0 5.186v2.593h10.37v-2.593h-10.37Z",
    fill: "#82ceee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.616 259.142a1.296 1.296 0 0 0-.892.396l-10.288 10.291-.083.078a1.296 1.296 0 0 0-.283.425 1.295 1.295 0 0 0-.09.4l-.006.09v41.485a1.296 1.296 0 0 0 1.493 1.296h41.288l.042-.005a1.292 1.292 0 0 0 .124-.01 1.29 1.29 0 0 0 .213-.044h.005l.036-.01a1.29 1.29 0 0 0 .122-.052c.027-.013.054-.025.08-.04l.032-.02a1.301 1.301 0 0 0 .212-.153l.052-.044.013-.016 10.358-10.355c.243-.244.38-.574.379-.918V260.45c0-.583-.39-1.095-.952-1.25a1.296 1.296 0 0 0-.127-.03 1.297 1.297 0 0 0-.127-.016 1.298 1.298 0 0 0-.09 0h-41.247a1.296 1.296 0 0 0-.264-.016Zm.562 2.608h37.819l-7.778 7.778H1393.4l7.778-7.778Zm39.652 1.833v37.819l-7.778 7.778v-37.818l7.778-7.779Zm-49.263 8.538h38.892v38.892h-38.892v-38.892Zm2.593 23.335v2.593h15.557v-2.593h-15.557Zm0 5.186v2.593h10.37v-2.593h-10.37Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    stroke: "#82ceee",
    fill: "transparent"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductBox);
export default __webpack_public_path__ + "static/media/ProductBox.94c2ac771c692d5eba676b2510544b0a.svg";
export { ForwardRef as ReactComponent };